(function($) {
     jQuery('.gallery_slick-js').slick({
          dots: false,
          infinite: true,
          speed: 300,
          autoplay: false,
          slidesToShow: 2,
          centerMode: true,
          prevArrow: '<button type="button" class="slick-prev"><i class="fas fa-angle-left"></i></button>',
          nextArrow: '<button type="button" class="slick-next"><i class="fas fa-angle-right"></i></button>',
          arrows: true,
          slidesToScroll: 1,
          responsive: [
               {
                 breakpoint: 600,
                 settings: {
                   slidesToShow: 1,
                   centerMode: false,
                 }
               }
          ]
     });

     $(document).ready(function () {   
     var btnLoadmore = $('.btn-loadmore-js');
     var ItemGallery = $('.gallery_item');

     if ( ItemGallery.length <= 5 ) {
          btnLoadmore.removeClass('d-inline-block').addClass('d-none');
     };


       $(btnLoadmore).click( function() {
           var postID = $(this).attr('data-id');
           var blockID = $(this).attr('data-block');

           $.ajax({
             url: ajaxurl,
             type: "POST",
             data: {
               'action': 'more_load_gallery',
               'post_id'  : postID,
               'block_id'  : blockID
             }
           }).done(function(response) {

          
               // $all_fields = get_block_data($postID, $blockID);
               // $gallery = $all_fields['gallery'];
               // $total   = count($gallery);

               // console.log($total);
             if(response) {
               $('.gallery__items').find('.gallery_item:last-of-type').after(response);

             } 
           });
           $(btnLoadmore).removeClass('d-inline-block').addClass('d-none');

       });
   
     });
   })(jQuery);